import { useTenant } from './useTenant';

interface Branding {
  logoUrl: string;
  primaryColor: string;
  accentColor: string;
  fontFamily: string | null;
  orgName: string;
  isCustomBranded: boolean;
}

const DEFAULT_PRIMARY = '#186DE9';
const DEFAULT_ACCENT = '#2C9C7F';

export function useBranding(): Branding {
  const { currentOrg } = useTenant();
  return {
    logoUrl: currentOrg?.logo_url || '/logo.png',
    primaryColor: currentOrg?.primary_color || DEFAULT_PRIMARY,
    accentColor: currentOrg?.accent_color || DEFAULT_ACCENT,
    fontFamily: currentOrg?.font_family || null,
    orgName: currentOrg?.name || 'Vintage',
    isCustomBranded: !!(currentOrg?.logo_url || currentOrg?.primary_color || currentOrg?.accent_color || currentOrg?.font_family),
  };
}
